import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WaitDialog = _resolveComponent("WaitDialog")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_m_btn = _resolveComponent("m-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_UserNotification = _resolveComponent("UserNotification")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_WaitDialog, {
        isActive: $setup.isWaiting,
        title: "What are you waiting for?"
      }, null, 8 /* PROPS */, ["isActive"]),
      _createVNode(_component_v_tabs, {
        modelValue: $setup.tab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.tab) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, { value: "1" }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode("Colors")
            ])),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_tab, { value: "2" }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("Buttons")
            ])),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_tab, { value: "3" }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode("Notifications")
            ])),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_tab, { value: "4" }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode("Dialogs")
            ])),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_tab, { value: "5" }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createTextVNode("Data")
            ])),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue"]),
      _createVNode(_component_v_tabs_window, {
        modelValue: $setup.tab,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.tab) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tabs_window_item, { value: "1" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "3",
                        md: "3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            title: "Primary Container",
                            class: "pc text-left"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => _cache[13] || (_cache[13] = [
                                  _createTextVNode(" This is what text looks like on a primary container. ")
                                ])),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_v_card_actions, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_m_btn, {
                                    text: "Action 1",
                                    color: "primary"
                                  }),
                                  _createVNode(_component_m_btn, { text: "Action 2" })
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_col, {
                        cols: "3",
                        md: "3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            title: "Secondary Container",
                            class: "sc text-left"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => _cache[14] || (_cache[14] = [
                                  _createTextVNode(" This is what text looks like on a secondary container. ")
                                ])),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_v_card_actions, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_m_btn, {
                                    text: "Action 1",
                                    color: "secondary"
                                  }),
                                  _createVNode(_component_m_btn, { text: "Action 2" })
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_col, {
                        cols: "3",
                        md: "3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            title: "Tertiary Container",
                            class: "tc text-left"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => _cache[15] || (_cache[15] = [
                                  _createTextVNode(" This is what text looks like on a tertiary container. ")
                                ])),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_v_card_actions, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_m_btn, {
                                    text: "Action 1",
                                    color: "tertiary"
                                  }),
                                  _createVNode(_component_m_btn, { text: "Action 2" })
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            title: "Success",
                            class: "bg-success text-on-success text-left"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => _cache[16] || (_cache[16] = [
                                  _createTextVNode(" This is what success looks like. ")
                                ])),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            title: "Information",
                            class: "bg-info text-on-info text-left"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => _cache[17] || (_cache[17] = [
                                  _createTextVNode(" This is what information looks like. ")
                                ])),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            title: "Warnings",
                            class: "bg-warning text-on-warning text-left"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => _cache[18] || (_cache[18] = [
                                  _createTextVNode(" This is what warnings looks like. ")
                                ])),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            title: "Errors",
                            class: "bg-error text-on-error text-left"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => _cache[19] || (_cache[19] = [
                                  _createTextVNode(" This is what errors looks like. ")
                                ])),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_tabs_window_item, { value: "2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            title: "Basic",
                            class: "text-left btns"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { class: "pa-4" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "2" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_m_btn, { text: "Default" })
                                    ]),
                                    _: 1 /* STABLE */
                                  }),
                                  _createVNode(_component_v_col, { cols: "2" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_m_btn, {
                                        color: "primary",
                                        text: "Primary"
                                      })
                                    ]),
                                    _: 1 /* STABLE */
                                  }),
                                  _createVNode(_component_v_col, { cols: "2" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_m_btn, {
                                        color: "secondary",
                                        text: "Secondary"
                                      })
                                    ]),
                                    _: 1 /* STABLE */
                                  }),
                                  _createVNode(_component_v_col, { cols: "2" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_m_btn, {
                                        color: "tertiary",
                                        text: "Tertiary"
                                      })
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_tabs_window_item, { value: "3" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            title: "Toasts",
                            class: "text-left btns"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { class: "pa-4" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "3" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_m_btn, {
                                        text: "Success",
                                        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.tell.success('Whew. That worked.')))
                                      })
                                    ]),
                                    _: 1 /* STABLE */
                                  }),
                                  _createVNode(_component_v_col, { cols: "3" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_m_btn, {
                                        text: "Information",
                                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.tell.info('Very informative stuff.')))
                                      })
                                    ]),
                                    _: 1 /* STABLE */
                                  }),
                                  _createVNode(_component_v_col, { cols: "3" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_m_btn, {
                                        text: "Warning",
                                        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.tell.warning('Something bad is about to happen.')))
                                      })
                                    ]),
                                    _: 1 /* STABLE */
                                  }),
                                  _createVNode(_component_v_col, { cols: "3" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_m_btn, {
                                        text: "Error",
                                        onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.tell.error('You broke it.')))
                                      })
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            title: "App Notifications",
                            class: "text-left btns"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { class: "pa-4" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "3" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_m_btn, {
                                        text: "Basic",
                                        onClick: $setup.sendAppNotification
                                      }, null, 8 /* PROPS */, ["onClick"])
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            title: "User Notifications",
                            class: "text-left btns"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { class: "pa-4" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "3" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_UserNotification, {
                                        message: "This is an error notification.",
                                        type: "error"
                                      })
                                    ]),
                                    _: 1 /* STABLE */
                                  }),
                                  _createVNode(_component_v_col, { cols: "3" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_UserNotification, {
                                        message: "This is a warning notification.",
                                        type: "warning"
                                      })
                                    ]),
                                    _: 1 /* STABLE */
                                  }),
                                  _createVNode(_component_v_col, { cols: "3" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_UserNotification, {
                                        message: "This is an info notification.",
                                        type: "info"
                                      })
                                    ]),
                                    _: 1 /* STABLE */
                                  }),
                                  _createVNode(_component_v_col, { cols: "3" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_UserNotification, {
                                        message: "This is a success notification.",
                                        type: "success"
                                      })
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_tabs_window_item, { value: "4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            title: "Dialogs",
                            class: "text-left"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { class: "pa-4" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "3" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_dialog, {
                                        modelValue: $setup.dialog,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.dialog) = $event)),
                                        "max-width": "400",
                                        persistent: ""
                                      }, {
                                        activator: _withCtx(({ props: activatorProps }) => [
                                          _createVNode(_component_m_btn, _mergeProps(activatorProps, { class: "moe-button" }), {
                                            default: _withCtx(() => _cache[20] || (_cache[20] = [
                                              _createTextVNode(" Confirmation ")
                                            ])),
                                            _: 2 /* DYNAMIC */
                                          }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card, {
                                            "prepend-icon": "mdi-map-marker",
                                            text: "Do you really want to do that?",
                                            title: "Are you sure?"
                                          }, {
                                            actions: _withCtx(() => [
                                              _createVNode(_component_v_spacer),
                                              _createVNode(_component_m_btn, {
                                                onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.dialog = false)),
                                                text: "Nevermind",
                                                color: "primary"
                                              }),
                                              _createVNode(_component_m_btn, {
                                                onClick: $setup.confirmDialog,
                                                text: "Yes!"
                                              }, null, 8 /* PROPS */, ["onClick"])
                                            ]),
                                            _: 1 /* STABLE */
                                          })
                                        ]),
                                        _: 1 /* STABLE */
                                      }, 8 /* PROPS */, ["modelValue"])
                                    ]),
                                    _: 1 /* STABLE */
                                  }),
                                  _createVNode(_component_v_col, { cols: "3" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_m_btn, {
                                        onClick: $setup.startWaiting,
                                        text: "Wait for it..."
                                      }, null, 8 /* PROPS */, ["onClick"])
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_tabs_window_item, { value: "5" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, { class: "text-left" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_data_table, {
                                headers: $setup.headers,
                                items: $setup.drivers,
                                "items-per-page": $setup.itemsPerPage,
                                page: $setup.page,
                                class: "elevation-1",
                                "show-current-page": "",
                                "footer-props": {
										itemsPerPageOptions: [5, 10, 20],
										showFirstLastPage: true
									}
                              }, {
                                top: _withCtx(() => [
                                  _createVNode(_component_v_toolbar, { flat: "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_toolbar_title, null, {
                                        default: _withCtx(() => _cache[21] || (_cache[21] = [
                                          _createTextVNode("Table Title + Toolbar (if needed)")
                                        ])),
                                        _: 1 /* STABLE */
                                      }),
                                      _createVNode(_component_v_divider, {
                                        class: "mx-4",
                                        inset: "",
                                        vertical: ""
                                      }),
                                      _createVNode(_component_m_btn, {
                                        color: "primary",
                                        "prepend-icon": "mdi-plus"
                                      }, {
                                        default: _withCtx(() => _cache[22] || (_cache[22] = [
                                          _createTextVNode("Add")
                                        ])),
                                        _: 1 /* STABLE */
                                      }),
                                      _createVNode(_component_m_btn, {
                                        class: "mx-2",
                                        "prepend-icon": "mdi-download"
                                      }, {
                                        default: _withCtx(() => _cache[23] || (_cache[23] = [
                                          _createTextVNode("Export")
                                        ])),
                                        _: 1 /* STABLE */
                                      }),
                                      _createVNode(_component_m_btn, { "prepend-icon": "mdi-refresh" }, {
                                        default: _withCtx(() => _cache[24] || (_cache[24] = [
                                          _createTextVNode("Refresh")
                                        ])),
                                        _: 1 /* STABLE */
                                      })
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["headers", "items", "items-per-page", "page"])
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue"])
    ]),
    _: 1 /* STABLE */
  }))
}